import axiosPost from '../axiosPost';

export const tarjetasEmisoresDel = async (arg) => {
    const { id } = arg

    const body = {
        "service": "GWCardEmisorDel",
        "params": {
            "gwcardEmisorId": id
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
};